import { pxToRem, captionClassName } from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';

const LIST_PADDING_LEFT = '40px';
const LIST_MARGIN_BOTTOM = pxToRem(16);

export const TabWrapper: StyleRule = ({ theme }) => ({
    display: 'grid',
    gridGap: pxToRem(20),
    [theme.screen.tablet]: {
        gridGap: pxToRem(64),
    },
});

export const SectionHeading: StyleRule = ({
    theme: { siteVariables, screen },
}) => ({
    paddingTop: 0,
    marginBottom: pxToRem(17),
    letterSpacing: pxToRem(0.2),

    [`&.${captionClassName}`]: {
        fontSize: pxToRem(20),
        lineHeight: 1.75,
        letterSpacing: pxToRem(0.4),
        ...siteVariables.textStyles.Text.Medium65,
    },

    [screen.max.tablet]: {
        lineHeight: siteVariables.lineHeightDefault,
        height: pxToRem(24),
        marginBottom: pxToRem(12),
        paddingTop: 0,
        borderBottomWidth: pxToRem(1),
    },
});

export const SectionContent: StyleRule = ({
    theme: { siteVariables, screen },
}) => ({
    borderBottom: `1px solid ${siteVariables.colors.primitive.black}`,
    paddingBottom: pxToRem(20),
    color: siteVariables.colors.charcoal['000'],
    '& ul, & menu': {
        listStyle: 'unset',
        paddingLeft: LIST_PADDING_LEFT,
        marginBottom: LIST_MARGIN_BOTTOM,
    },
    '& ol': {
        listStyle: 'unset',
        paddingLeft: LIST_PADDING_LEFT,
        marginBottom: LIST_MARGIN_BOTTOM,
    },
    '& p': {
        marginBottom: pxToRem(16),
    },
    '& > *': {
        margin: 0,
        fontSize: siteVariables.fontSizes.caption04,
        lineHeight: siteVariables.lineHeightSmall,
        color: siteVariables.colors.charcoal['000'],
        ...siteVariables.textStyles.Text.Roman55,

        '& b, strong': {
            fontWeight: siteVariables.textStyles.Text.Medium65.fontWeight,
        },

        [screen.min.tablet]: {
            fontSize: siteVariables.fontSizes.caption03,
            letterSpacing: siteVariables.letterSpacingMedium,
            lineHeight: 1.5,
            color: siteVariables.colors.charcoal['250'],
        },
    },

    '& a': {
        textDecoration: 'underline',
        color: siteVariables.colors.charcoal['250'],
        '&:hover': {
            color: siteVariables.colors.primitive.black,
        },
    },

    '& > :not(:first-child)': {
        marginTop: pxToRem(30),
    },
});
